// Place your custom JavaScript here.
$(document).ready(function () {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		// Skip if it has this class
		if ($(this).hasClass('no-automatic-responsiveness')) return;
		if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	if ($('.product-image-slider').length && $('.product-thumbnail-slider').length) {
		const galleryThumbs = new Swiper('.product-thumbnail-slider', {
			slidesPerView: 5,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: true,
			},
		});
		const galleryTop = new Swiper('.product-image-slider', {
			autoHeight: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: galleryThumbs,
			},
		});
	}

	if ($('.review-slider').length) {
		const reviewSlider = new Swiper('.review-slider', {
			loop: true,
			centeredSlides: true,
			slidesPerView: 1,
			spaceBetween: 10,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				1024: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
				640: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		});
	}

	$(document).on('click', '.plus', function (e) {
		$input = $(this).parent().prev('input.qty');
		$inputName = $input.attr('name');
		$inputID = $input.attr('id');
		// Search for second input with the same name to work around correctly updating the cart.
		$secondInput = $(`input[name='${$inputName}']:not([id='${$inputID}'])`);
		const max = parseInt($input.attr('max'));
		const val = parseInt($input.val());
		let step = $input.attr('step');
		step = 'undefined' !== typeof step ? parseInt(step) : 1;
		if (isNaN(max) || val < max) {
			$input.val(val + step).change();
			if ($secondInput.length !== 0) {
				$secondInput.val(val + step).change();
			}
		}
	});
	$(document).on('click', '.minus', function (e) {
		$input = $(this).parent().next('input.qty');
		$inputName = $input.attr('name');
		$inputID = $input.attr('id');
		// Search for second input with the same name to work around correctly updating the cart.
		$secondInput = $(`input[name='${$inputName}']:not([id='${$inputID}'])`);
		const val = parseInt($input.val());
		let step = $input.attr('step');
		step = 'undefined' !== typeof step ? parseInt(step) : 1;
		if (val > 0) {
			$input.val(val - step).change();
			if ($secondInput.length !== 0) {
				$secondInput.val(val - step).change();
			}
		}
	});

	$(document).on('click', '.add-composite-to-cart', function (e) {
		e.preventDefault();

		var $thisbutton = $(this),
			product_id = $thisbutton.data('product-id');
		variation_id = $thisbutton.data('variation-id');
		quantity = $thisbutton.parent().find('input').val() || 1;

		var data = {
			action: 'woocommerce_ajax_add_composite_to_cart',
			product_id: product_id,
			variation_id: variation_id,
			quantity: quantity,
		};

		$(document.body).trigger('adding_to_cart', [$thisbutton, data]);

		$.ajax({
			type: 'post',
			url: wc_add_to_cart_params.ajax_url,
			data: data,
			beforeSend: function (response) {
				$('.added_to_cart').remove();
				$thisbutton.prop('disabled', true);
				$thisbutton.removeClass('added').addClass('loading');
			},
			complete: function (response) {
				$thisbutton.prop('disabled', false);
				$thisbutton.addClass('added').removeClass('loading');
			},
			success: function (response) {
				if (response.error && response.product_url) {
					window.location = response.product_url;
					return;
				} else {
					$(document.body).trigger('added_to_cart', [
						response.fragments,
						response.cart_hash,
						$thisbutton.parent(),
					]);
					window.location.reload();
				}
			},
		});

		return false;
	});

	$('#billing_email_field').append(
		'<i>De factuur- en verzendinformatie van de bestelling wordt per e-mail toegezonden.</i>'
	);

	if ($('form.cart').length) {
		$('form.cart').prepend('<div class="prevdesc"><span id="descpdp"></span><a href="#tab-description">Lees meer</a></div>');
		$('span#descpdp')[0].innerText = $('.woocommerce-Tabs-panel--description p')[0].innerText;
	}
});

(($) => {
	/*
	 *  new_map
	 *
	 *  This function will render a Google Map onto the selected jQuery element
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$el (jQuery element)
	 *  @return	n/a
	 */

	function new_map($el) {
		// var
		const $markers = $el.find('.marker');

		// vars
		const args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
		};

		// create map
		const map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			add_marker($(this), map);
		});

		// center map
		center_map(map);

		// return
		return map;
	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker($marker, map) {
		// var
		const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		const marker = new google.maps.Marker({
			position: latlng,
			map,
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			const infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', () => {
				infowindow.open(map, marker);
			});
		}
	}

	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map(map) {
		// vars
		const bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, (i, marker) => {
			const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(13);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	let map = null;

	$(document).ready(() => {
		$('.acf-map').each(function () {
			// create map
			map = new_map($(this));
		});
	});
})(jQuery);
